// Platzhalter im gespeicherten Custom-Header-HTML (ChatbotConfig.customHeaderHtml).
// Werte, die sich nach dem Erzeugen des HTML noch ändern können (Profilbild, Bot-Farbe),
// werden erst beim Rendern im Bot bzw. in der Admin-Vorschau eingesetzt.
export const CUSTOM_HEADER_PLACEHOLDERS = {
  avatar: "{{AVATAR_PLACEHOLDER}}",
  color: "{{BOT_COLOR}}",
  contrastColor: "{{BOT_CONTRAST_COLOR}}"
} as const;

export type CustomHeaderRenderValues = {
  botId: string;
  hasImage: boolean;
  icon: string | undefined;
  // Farbe des Headers (getColorFromConfig(config, true))
  color: string;
  contrastColor: string;
  // Farbe des Icon-Avatars (getColorFromConfig(config, false))
  iconColor: string;
  iconContrastColor: string;
};

const escapeHtml = (value: string): string => value
  .replaceAll("&", "&amp;")
  .replaceAll("<", "&lt;")
  .replaceAll(">", "&gt;")
  .replaceAll('"', "&quot;")
  .replaceAll("'", "&#039;");

const buildAvatarHtml = (values: CustomHeaderRenderValues): string => values.hasImage
  ? `<img src="/api/toolbox/membot/public/botimg/${encodeURIComponent(values.botId)}/128" class="rounded-circle" style="width: 40px; height: 40px; object-fit: cover;" alt="">`
  : `<i style="background-color: ${escapeHtml(values.iconColor)}; color: ${escapeHtml(values.iconContrastColor)};" class="ri-2x p-2 rounded-circle ${escapeHtml(values.icon ?? "")}"></i>`;

export const renderCustomHeaderHtml = (html: string | null | undefined, values: CustomHeaderRenderValues): string => (html ?? "")
  .replaceAll(CUSTOM_HEADER_PLACEHOLDERS.avatar, buildAvatarHtml(values))
  .replaceAll(CUSTOM_HEADER_PLACEHOLDERS.color, escapeHtml(values.color))
  .replaceAll(CUSTOM_HEADER_PLACEHOLDERS.contrastColor, escapeHtml(values.contrastColor));
